import Popup from "reactjs-popup";
import { UseAssembly } from "../../Store/entities/assemblies/hooks";
import React, { ReactNode, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import HeaderData from "../NewItems/HeaderData";
import Button from "../../Parts/Button";
import { useQuoteTypeNameByQuoteId } from "../../Store/entities/quotes/hooks";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useErrorsBySeqAndQuoteId } from "../../Store/entities/assemblies/errors/hooks";

type ShadeSummaryNewProps = {
    quoteId: number;
    sequenceId: number;
}

const ShadeSummaryNew = ({ quoteId, sequenceId }: ShadeSummaryNewProps) => {
    const displayItems = [] as ReactNode[];

    const shadeData = UseAssembly(quoteId, sequenceId);
    if (!shadeData) return null;

    const shadeName = shadeData.shade_name;
    const quoteType = useQuoteTypeNameByQuoteId(quoteId);

    const errors = useErrorsBySeqAndQuoteId(quoteId, sequenceId);
    const errorMessage = errors.reduce((acc, e) => acc + " \n" + e.message, "");

    const [shadeSummaryOpen, setShadeSummaryOpen] = useState(false);
    const ignoredFields = [
        'cost',
        'base_sale_price',
        'dealer_sale_price',
        'api_motor_id',
        'hidden_shipping',
        'ShadesCost',
        'ShadesMsrp',
        'tube_name',
        'shades'
    ];


    Object.entries(shadeData).forEach(([key, valueData]) => {
        if (ignoredFields.includes(key)) return;

        if (key == "header_type") {
            const headerType = HeaderData().find(
                (i) => i.value == valueData
            );

            displayItems.push(
                <tr key={key}>
                    <th>Header Type:</th>
                    <td>{`${headerType?.name ?? valueData}`}</td>
                </tr>
            );
        } else {
            displayItems.push(
                <tr key={key}>
                    <th>{key}:</th>
                    <td>{`${valueData}`}</td>
                </tr>
            );
        }


    });

    shadeData?.shades?.forEach((s) => {
        displayItems.push(
            <tr key={`${s.row_coordinate}-${s.column_coordinate}`}>
                <th>
                    <h4>
                        Shade Row
                        {' '}
                        {s.row_coordinate}
                        {' '}
                        Column
                        {' '}
                        {s.column_coordinate}
                    </h4>
                </th>
            </tr>
        );

        let s_index = 0;

        for (const sKey in s) {
            if (ignoredFields.includes(sKey)) continue;

            let value = s[sKey];

            if (sKey == "motor") {
                if (value == 'DM35CEQ/S-2/28') {
                    value = '35 mm 12VDC Hardwired Motor';
                } else if (value == 'DM35LEQ/S-2/28') {
                    value = '35 mm Li-Ion RF Motor';
                }
            }

            s_index++;

            displayItems.push(
                <tr key={`s-${s_index}`}>
                    <th>
                        {sKey}
                        :
                        {' '}
                    </th>
                    <td>{value}</td>
                </tr>
            );
        }
    });

    return (
        <>
            <Popup
                open={shadeSummaryOpen}
                onClose={() => {
                    setShadeSummaryOpen(false);
                }}
                className="mobile-modal"
            >
                <div id="product-editor">
                    <div className="product-form">
                        <div style={{ overflowX: 'auto' }}>
                            <h2 className={`text-${quoteType}`}>
                                Summary for Shade: {shadeName}
                            </h2>
                            <table className="minimalistic-table">
                                <tbody>{displayItems}</tbody>
                            </table>
                            {(!shadeData.error_messages || shadeData.msrp != 0  ) && errors.length == 0 ? null : (
                                <>
                                    <h3 className="error shade-errors">Errors</h3>
                                    <h4 className="error shade-errors">
                                        {errorMessage ?? shadeData.error_messages}
                                    </h4>
                                   
                                </>
                            )}
                            <Container className="local-bootstrap">
                                <Row className="justify-content-center mt-2">
                                    <Col lg={4}>
                                        <Button
                                            color={quoteType ?? 'green'}
                                            fullWidth
                                            onClick={() => {
                                                setShadeSummaryOpen(false);
                                            }}
                                        >
                                            Done
                                        </Button>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    </div>
                </div>
            </Popup>
            <Button
					fullWidth
					color="light"
					size="sm"
					title="Detail View"
					hoverColor={quoteType}
					onClick={() => setShadeSummaryOpen(true)}
				>
					<FontAwesomeIcon
                    transform="grow-5"
                    icon={faEye}
                />
			</Button>
        </>
    );
}

export default ShadeSummaryNew;